import React from 'react';
function ScaleTable() {
    const tableData = [
        ['3.97 ~ 4.0', '4.26 ~ 4.3', '4.46 ~ 4.5', '4.95 ~ 5.00', 100],
        ['3.92 ~ 3.96', '4.22 ~ 4.25', '4.41 ~ 4.45', '4.90 ~ 4.94', 99],
        ['3.88 ~ 3.91', '4.17 ~ 4.21', '4.36 ~ 4.40', '4.84 ~ 4.89', 98],
        ['3.84 ~ 3.87', '4.12 ~ 4.16', '4.31 ~ 4.35', '4.79 ~ 4.83', 97],
        ['3.80 ~ 3.83', '4.08 ~ 4.11', '4.26 ~ 4.30', '4.73 ~ 4.78', 96],
        ['3.75 ~ 3.79', '4.03 ~ 4.07', '4.21 ~ 4.25', '4.68 ~ 4.72', 95],
        ['3.71 ~ 3.74', '3.98 ~ 4.02', '4.16 ~ 4.20', '4.62 ~ 4.67', 94],
        ['3.67 ~ 3.70', '3.93 ~ 3.97', '4.11 ~ 4.15', '4.57 ~ 4.61', 93],
        ['3.62 ~ 3.66', '3.89 ~ 3.92', '4.06 ~ 4.10', '4.51 ~ 4.56', 92],
        ['3.58 ~ 3.61', '3.84 ~ 3.88', '4.01 ~ 4.05', '4.45 ~ 4.50', 91],
        ['3.49 ~ 3.57', '3.75 ~ 3.83', '3.91 ~ 4.00', '4.34 ~ 4.44', 90],
        ['3.41 ~ 3.48', '3.65 ~ 3.74', '3.81 ~ 3.90', '4.23 ~ 4.33', 89],
        ['3.32 ~ 3.40', '3.56 ~ 3.64', '3.71 ~ 3.80', '4.12 ~ 4.22', 88],
        ['3.24 ~ 3.31', '3.46 ~ 3.55', '3.61 ~ 3.70', '4.01 ~ 4.11', 87],
        ['3.15 ~ 3.23', '3.37 ~ 3.45', '3.51 ~ 3.60', '3.90 ~ 4.00', 86],
        ['3.07 ~ 3.14', '3.27 ~ 3.36', '3.41 ~ 3.50', '3.79 ~ 3.89', 85],
        ['2.98 ~ 3.06', '3.18 ~ 3.26', '3.31 ~ 3.40', '3.68 ~ 3.78', 84],
        ['2.90 ~ 2.97', '3.09 ~ 3.17', '3.21 ~ 3.30', '3.57 ~ 3.67', 83],
        ['2.81 ~ 2.89', '2.99 ~ 3.08', '3.11 ~ 3.20', '3.45 ~ 3.56', 82],
        ['2.72 ~ 2.80', '2.90 ~ 2.98', '3.01 ~ 3.10', '3.34 ~ 3.44', 81],
        ['2.64 ~ 2.71', '2.80 ~ 2.89', '2.91 ~ 3.00', '3.23 ~ 3.33', 80],
        ['2.56 ~ 2.63', '2.70 ~ 2.79', '2.81 ~ 2.90', '3.12 ~ 3.22', 79],
        ['2.48 ~ 2.55', '2.61 ~ 2.69', '2.71 ~ 2.80', '3.01 ~ 3.11', 78],
        ['2.40 ~ 2.47', '2.52 ~ 2.60', '2.61 ~ 2.70', '2.90 ~ 3.00', 77],
        ['2.32 ~ 2.39', '2.43 ~ 2.51', '2.51 ~ 2.60', '2.79 ~ 2.89', 76],
        ['2.24 ~ 2.31', '2.34 ~ 2.42', '2.41 ~ 2.50', '2.68 ~ 2.78', 75],
        ['2.16 ~ 2.23', '2.25 ~ 2.33', '2.31 ~ 2.40', '2.57 ~ 2.67', 74],
        ['2.08 ~ 2.15', '2.16 ~ 2.24', '2.21 ~ 2.30', '2.46 ~ 2.56', 73],
        ['2.00 ~ 2.07', '2.07 ~ 2.15', '2.11 ~ 2.20', '2.35 ~ 2.45', 72],
        ['1.92 ~ 1.99', '1.98 ~ 2.06', '2.01 ~ 2.10', '2.24 ~ 2.34', 71],
        ['1.84 ~ 1.91', '1.89 ~ 1.97', '1.91 ~ 2.00', '2.13 ~ 2.23', 70],
        ['1.75 ~ 1.83', '1.80 ~ 1.88', '1.81 ~ 1.90', '2.02 ~ 2.12', 69],
        ['1.67 ~ 1.74', '1.71 ~ 1.79', '1.71 ~ 1.80', '1.92 ~ 2.01', 68],
        ['1.59 ~ 1.66', '1.62 ~ 1.70', '1.61 ~ 1.70', '1.82 ~ 1.91', 67],
        ['1.51 ~ 1.58', '1.53 ~ 1.61', '1.51 ~ 1.60', '1.71 ~ 1.81', 66],
        ['1.43 ~ 1.50', '1.44 ~ 1.52', '1.41 ~ 1.50', '1.60 ~ 1.70', 65],
        ['1.35 ~ 1.42', '1.36 ~ 1.43', '1.31 ~ 1.40', '1.50 ~ 1.59', 64],
        ['1.26 ~ 1.34', '1.28 ~ 1.35', '1.21 ~ 1.30', '1.40 ~ 1.49', 63],
        ['1.18 ~ 1.25', '1.19 ~ 1.27', '1.11 ~ 1.20', '1.31 ~ 1.39', 62],
        ['1.09 ~ 1.17', '1.10 ~ 1.18', '1.01 ~ 1.10', '1.21 ~ 1.30', 61],
        ['1.00 ~ 1.08', '1.00 ~ 1.09', '0.91 ~ 1.00', '1.11 ~ 1.20', 60],
        ['0.00 ~ 0.99', '0.00 ~ 0.99', '0.00 ~ 0.90', '0.00 ~ 1.10', 'رسوب'],
    ];
    return (
        <div>
            <table >
                <thead>
                    <tr className='gpa-header'>
                        <th>4.0 Scall</th>
                        <th>4.3 Scall</th>
                        <th>4.5 Scall</th>
                        <th>5.0 Scall</th>
                        <th>100 Scall</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((row, index) => (
                        <tr key={index}>
                            {row.map((cell, cellIndex) => (
                                <td key={cellIndex}>{cell}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
export default ScaleTable;
